import { lazy } from 'react';
export const LazyNotFoundPage = lazy(() => import('./not-found.page'));
